/* eslint-disable object-curly-newline */
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import API from 'src/utils/apiConfig';
import { changePassword } from 'src/utils/cognito';

const PasswordExpired = ({ username, onClick }) => {
  const [loading, setLoading] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword1, setNewPassword1] = useState('');
  const [newPassword2, setNewPassword2] = useState('');

  const handlePasswordUpdate = async () => {
    setLoading(true);
    try {
      if (newPassword1 !== newPassword2) throw new Error('New passwords did not match');
      await changePassword(oldPassword, newPassword1);
      const r = await API.patch('/v1/users/self', {
        username,
        passwordLastReset: Date.now(),
      });
      if (!r.data.success) throw new Error(r.data.message);
      toast.success('Password updated successfully');
      setOldPassword('');
      setNewPassword1('');
      setNewPassword2('');
      onClick();
    } catch (err) {
      toast.error(err.response?.data.message || err.response?.data || err.message);
    }
    setLoading(false);
  };

  return (
    <Dialog open maxWidth="md" fullWidth>
      <DialogTitle>Password expired</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Typography>
          Your password has expired. Please create a new password below to continue. After updating, log in again with your new password.
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Typography fontWeight="bold" sx={{ width: '25%' }}>Old password:</Typography>
          <TextField
            type="password"
            fullWidth
            size="small"
            variant="outlined"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
          />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Typography fontWeight="bold" sx={{ width: '25%' }}>New password:</Typography>
          <TextField
            type="password"
            fullWidth
            size="small"
            variant="outlined"
            value={newPassword1}
            onChange={(e) => setNewPassword1(e.target.value)}
          />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Typography fontWeight="bold" sx={{ width: '25%' }}>Confirm password:</Typography>
          <TextField
            type="password"
            fullWidth
            size="small"
            variant="outlined"
            value={newPassword2}
            onChange={(e) => setNewPassword2(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handlePasswordUpdate} disabled={!oldPassword || !newPassword1 || !newPassword2}>
          {loading && <CircularProgress size={20} sx={{ color: 'white', marginRight: '0.5rem' }} />}
          Update & Logout
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PasswordExpired;
